module.exports = __webpack_public_path__ + "img/loving_heart_n.e5350bc4.svg";